import { apiGetAuth, apiPostAuth, apiPutAuth } from '@/utils/api'
import { API_SEARCH_RESULT_MONETIZATION } from '@/utils/api-url'
import { notificationDanger } from '@/utils/notification'

const state = () => {
  return {
    search_result_list: { data: [] },
    detail_search_result: {},
    data_modal_add_edit: {},
    meta_filter: {},
    toggle_modal_add_edit_discard: {
      targetModals: false,  
      title: '', 
      description: '',
      customTitleBtnOk: '',
      customClass: '',
      type: '',
      loadingTable: false,
      loadingPopUp: false
    }
  }
}

const mutations = {
  SET_SEARCH_RESULT_LIST (state, payload) {
    state.search_result_list = payload
  },
  SET_DETAIL_SEARCH_RESULT (state, payload) {
    state.detail_search_result = payload
  },
  SET_DATA_MODAL_ADD_EDIT (state, payload) {
    state.data_modal_add_edit = payload
  },
  SET_TOGGLE_MODAL_ADD_EDIT_DISCARD (state, payload) {
    state.toggle_modal_add_edit_discard = payload
  },
  SET_META_FILTER (state, payload) {
    state.meta_filter = payload
  }
}

const actions = {
  async getListSearchResult (context, payload) {
    try {
      const response = await apiGetAuth(API_SEARCH_RESULT_MONETIZATION.LIST_SEARCH_RESULT, payload)
      
      const fallbackData = response?.data || { data: [] }
      context.commit('SET_SEARCH_RESULT_LIST', fallbackData)
    } catch (error) {
      const safeStatus = error?.response?.status || 500
      const safeMessage = error?.response?.data?.message || 'Failed to fetch list.'

      console.error('[Store Action Error: getListSearchResult] Request failed with HTTP Status:', safeStatus)
      notificationDanger(safeMessage)
    }
  },

  async createSearchResult (context, payload) {
    try {
      const response = await apiPostAuth(API_SEARCH_RESULT_MONETIZATION.CREATE_SEARCH_RESULT, payload)
      return response?.data || null
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })

      console.error('[Store Action Error: createSearchResult] API failure:', { payload, error })
      const enrichedError = Object.assign(error, {
        storeAction: 'createSearchResult',
        dispatchedPayload: payload
      })

      return Promise.reject(enrichedError) 
    }
  },

  async getDetailSearchResult (context, id) {
    if (!id) {
      console.error('[Store Error: getDetailSearchResult] Parameter ID wajib dikirim.')
      return null
    }

    try {
      const response = await apiGetAuth(API_SEARCH_RESULT_MONETIZATION.DETAIL_SEARCH_RESULT(id))
      
      const campaignData = response?.data?.data || {}
      
      context.commit('SET_DETAIL_SEARCH_RESULT', campaignData)
      return campaignData

    } catch (error) {
      const safeStatus = error?.response?.status || 500
      const safeMessage = error?.response?.data?.message || 'Gagal mengambil data detail campaign.'
      
      console.error(`[Store Action Error: getDetailSearchResult] Failed for ID ${id} with Status:`, safeStatus)
      notificationDanger(safeMessage)
      
      return Promise.reject(new Error(safeMessage))
    }
  },

  async updateSearchResult (context, payload) {
    if (!payload?.id) {
      const validationError = new Error('Failed to update: Missing required payload ID.')
      console.error(validationError.message, payload)
      notificationDanger('Unable to update data. Invalid reference ID.')
      return null
    }

    try {
      const response = await apiPutAuth(API_SEARCH_RESULT_MONETIZATION.UPDATE_SEARCH_RESULT(payload.id), payload.reqBody)
      return response?.data || null
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })

      console.error('[Store Action Error: updateSearchResult] API failure:', { id: payload.id, reqBody: payload.reqBody, error })
      const enrichedError = Object.assign(error, {
        storeAction: 'updateSearchResult',
        targetId: payload.id,
        dispatchedPayload: payload.reqBody
      })

      return Promise.reject(enrichedError) 
    }
  },

  async uploadBulkSearchResult (context, payload) {
    try {
      const response = await apiPostAuth(API_SEARCH_RESULT_MONETIZATION.UPLOAD_BULK_SEARCH_RESULT, payload)
      return response?.data || null
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })

      console.error('[Store Action Error: uploadBulkSearchResult] API failure:', { payload, error })
      const enrichedError = Object.assign(error, {
        storeAction: 'uploadBulkSearchResult',
        dispatchedPayload: payload
      })
      return Promise.reject(enrichedError) 
    }
  },

  async validateBulkKeyword (context, payload) {
    try {
      const response = await apiPostAuth(API_SEARCH_RESULT_MONETIZATION.VALIDATE_KEYWORD_SEARCH_RESULT, payload)
      return response?.data || null
    } catch (error) {
      console.error('[Store Error: validateBulkKeyword]', error)
      return Promise.reject(error)
    }
  },

  async validateBulkPlu (context, payload) {
    try {
      const response = await apiPostAuth(API_SEARCH_RESULT_MONETIZATION.VALIDATE_PLU_SEARCH_RESULT, payload)
      return response?.data || null
    } catch (error) {
      console.error('[Store Error: validateBulkPlu]', error)
      return Promise.reject(error)
    }
  },

  async updatePrioritySearchResult (context, payload) {
    if (!payload?.reqBody) {
      console.error('[Store Action Error: updatePrioritySearchResult] Missing reqBody:', payload)
      notificationDanger('Unable to update priority. Invalid request body.')
      return null
    }

    try {
      const response = await apiPutAuth(API_SEARCH_RESULT_MONETIZATION.UPDATE_PRIORITY_SEARCH_RESULT, payload.reqBody)
      
      return response?.data || null
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })

      console.error('[Store Action Error: updatePrioritySearchResult] API failure:', { 
        reqBody: payload.reqBody, 
        error 
      })

      return Promise.reject(error) 
    }
  }
}

const getters = {
  list_search_result (state) {
    return state.search_result_list
  },
  detail_search_result (state) {
    return state.detail_search_result
  },
  get_toggle_modal_add_edit_discard (state) {
    return state.toggle_modal_add_edit_discard
  },
  get_data_modal_add_edit (state) {
    return state.data_modal_add_edit
  },
  meta_filter (state) {
    return state.meta_filter
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
